import React, { cloneElement, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { Text } from '@beef/ui-kit';

// Utils
import { templateParser } from 'utils/formatString';
import { maskPhoneNumber } from 'utils/validators';
import { controlSebInvite } from '../store/actions';

// Constants
import { INVITE_ANSWERS } from '../constants';

const IncomingInviteHOC = ({ children }) => {
  const [isChecked, setChecked] = useState(false);
  const { incomingInvitation } = useSelector((state) => state.application);
  const dispatch = useDispatch();

  const { ctn, isSeb, incomingInvite, isLoading } = incomingInvitation;

  const {
    title,
    descriptionSeb,
    descriptionSdb,
    acceptButtonText,
    rejectButtonText,
    permissionServicesText,
    termUseText,
    termUserButtonText,
    termUserButtonLink,
  } = incomingInvite;

  const description = isSeb ? descriptionSeb : descriptionSdb;
  const maskedCellNumber = maskPhoneNumber(ctn);
  const currentTitle = templateParser(title, { NUMBER: maskedCellNumber });
  const currentPermission = templateParser(permissionServicesText, { NUMBER: maskedCellNumber });
  const permissionNode = (<Text size="size5-r-s" color="grey50">{currentPermission}</Text>);

  const handleCheckboxChange = useCallback(() => setChecked((prevState) => !prevState), []);

  const handleAcceptBtnClick = useCallback(() => {
    dispatch(controlSebInvite(INVITE_ANSWERS.accept, ctn, isChecked));
  }, [isChecked, ctn]);

  const handleRejectBtnClick = useCallback(() => {
    dispatch(controlSebInvite(INVITE_ANSWERS.reject, ctn, false));
  }, [ctn]);

  return (
    cloneElement(children, {
      title: currentTitle,
      description,
      acceptButtonText,
      label: permissionNode,
      rejectButtonText,
      termUseText,
      handleCheckboxChange,
      isChecked,
      acceptClick: handleAcceptBtnClick,
      rejectClick: handleRejectBtnClick,
      isLoading,
      termUserButtonText,
      termUserButtonLink,
    })
  );
};

export { IncomingInviteHOC };
